export class IamURIs {
  public static iamBase = (version: string = '1') => `/frameworkiam/v${version}`;

  // Reset Password
  public static resetPassword = (version: string = '1') => `${IamURIs.iamBase(version)}/users/password`;

  // Tokens
  public static getToken = (version: string = '2') => `${IamURIs.iamBase(version)}/users/token`;

  // MFA
  public static MfaTotp = '/frameworkiam/v1/users/mfa/totp';

  // Users Profile
  public static updateUserProfile = '/frameworkiam/v1/users/profile';
}
